import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { SITE, waLink } from "@/lib/site";

const NAV = [
  { id: "inicio",       label: "Inicio" },
  { id: "productos",    label: "Productos" },
  { id: "proceso",      label: "Proceso" },
  { id: "galeria",      label: "Galería" },
  { id: "testimonios",  label: "Testimonios" },
  { id: "contacto",     label: "Contacto" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const headerBg = scrolled
    ? "bg-[#111111] header-shadow"
    : "bg-transparent";

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${headerBg}`}
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 flex items-center justify-between h-[78px]">
        {/* Logo */}
        <a href="#inicio" data-testid="logo" className="flex items-center">
  <img
    src="/images/logo persia.png"
    alt="Persia Persianas y Cortinas"
    className="h-14 md:h-16 w-auto"
  />
</a>


        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={`nav-${n.id}`}
              className="font-display text-[12px] tracking-[0.18em] uppercase text-white/85 hover:text-gold transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-3">
          <a
            data-testid="header-cta-cotizar"
            href={waLink(`Hola, me gustaría una cotización de ${SITE.brand}.`)}
            target="_blank"
            rel="noreferrer"
            className="btn-gold"
          >
            Cotizar Ahora
          </a>
        </div>

        {/* Mobile burger */}
        <button
          data-testid="mobile-menu-toggle"
          aria-label="Menú"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.2, 0.6, 0.2, 1] }}
            className="lg:hidden bg-[#111111] overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <a
                  key={n.id}
                  href={`#${n.id}`}
                  onClick={() => setOpen(false)}
                  className="font-display text-sm tracking-[0.2em] uppercase text-white/85 hover:text-gold py-2"
                >
                  {n.label}
                </a>
              ))}
              <a
                href={waLink("Hola, me gustaría una cotización.")}
                target="_blank"
                rel="noreferrer"
                className="btn-gold mt-2 justify-center"
              >
                Cotizar Ahora
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
